import { render, staticRenderFns } from "./SafeTransactionHistory.vue?vue&type=template&id=0b699256&scoped=true&"
import script from "./SafeTransactionHistory.vue?vue&type=script&lang=js&"
export * from "./SafeTransactionHistory.vue?vue&type=script&lang=js&"
import style0 from "./SafeTransactionHistory.vue?vue&type=style&index=0&id=0b699256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b699256",
  null
  
)

export default component.exports